import React from 'react';
import SelectUnbindDevices from '../SelectUnbindDevices';
import { useTranslation } from 'react-i18next';
import useSelectDevices from '@root/hooks/defaultPackage/useSelectDevices';
import { isInIosApp } from '@root/shared';

const SelectDevice = () => {
  const {
    isUnlimited,
    selectedPrice,
    maxDevNum,
    paying,
    selected,
    payMethodState,
    onSelected,
    onClickPay,
  } = useSelectDevices();
  const { t } = useTranslation();

  return (
    <SelectUnbindDevices
      selected={selected}
      maxDevNum={maxDevNum}
      isUnlimited={isUnlimited}
      paying={paying}
      onChange={onSelected}
      onClickPay={onClickPay}
      btnText={t('purchase_now')}
      payMethodState={isInIosApp ? undefined : payMethodState}
    >
      {isUnlimited && (
        <div className="footer-tips">
          <span className="total">
            {t('total')}: ${selectedPrice.price}
            {` / ${t('month')}`}
          </span>
          <span className="float-right">{`${selected.length} ${
            selected.length > 1 ? t('devices') : t('device')
          }`}</span>
        </div>
      )}
    </SelectUnbindDevices>
  );
};

export default SelectDevice;
